import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';

export const shabashApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get nomination by employee id
    getShabashNominations: builder.query({
      query: (empCode) => `${ENDPOINTS.SHABASH.BY_NOMINEE}${empCode}`,
      providesTags: (result, error, id) =>
        result?.data
          ? [{ type: 'Shabash', id: 'LIST' }, ...result?.data.map(({ _id }) => ({ type: 'Shabash', id: _id }))]
          : [{ type: 'Shabash', id: 'LIST' }],
    }),
    // Nominate for shabash
    nominateForShabash: builder.mutation({
      query: (data) => ({
        url: ENDPOINTS.SHABASH.BASE,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ({ nomineeEmpCode }) => [
        { type: 'Shabash', id: 'LIST' },
        { type: 'Profile', id: nomineeEmpCode },
      ],
    }),
    // Shabash search, search in nomination with nomination reason and nominator name
    searchNominations: builder.query({
      query: (searchTerm) => `${ENDPOINTS.SHABASH.SEARCH}?q=${searchTerm}`,
      providesTags: (result) => (result ? [{ type: 'Shabash', id: 'LIST' }] : []),
    }),
    //Get all nominations of shabash if require
    getAllShabashNominations: builder.query({
      query: () => ENDPOINTS.SHABASH.BASE,
      providesTags: (result) =>
        result
          ? [{ type: 'Shabash', id: 'LIST' }, ...result?.data.map(({ _id }) => ({ type: 'Shabash', id: _id }))]
          : [{ type: 'Shabash', id: 'LIST' }],
    }),
    fetchProfile: builder.query({
      query: (userId) => `${ENDPOINTS.EMPLOYEE.PROFILE_BY_ID}${userId}`,
    }),
    getYears: builder.query({
      query: () => ENDPOINTS.SHABASH.GET_YEARS,
    }),
    // Get nominations by year and group by month
    getNominationsByYear: builder.query({
      query: (year) => `${ENDPOINTS.SHABASH.GET_WINNERS_BY_YEAR}?year=${year}`,
      providesTags: (result) => (result?.data ? [{ type: 'Shabash', id: 'LIST' }] : []),
    }),
    updateAdminNominationStatus: builder.mutation({
      query: ({ nominationId, adminRejectionReason }) => ({
        url: `${ENDPOINTS.SHABASH.UPDATE_STATUS}${nominationId}`,
        method: 'POST',
        body: { nominationId, adminRejectionReason },
      }),
      invalidatesTags: ({ nomineeEmpCode }) => [
        { type: 'Shabash', id: 'LIST' },
        { type: 'Shabash', id: nomineeEmpCode },
      ],
    }),
  }),
});

export const {
  useNominateForShabashMutation,
  useGetShabashNominationsQuery,
  useSearchNominationsQuery,
  useGetAllShabashNominationsQuery,
  useFetchProfileQuery,
  useGetYearsQuery,
  useGetNominationsByYearQuery,
  useUpdateAdminNominationStatusMutation,
} = shabashApiSlice;
